import { useErrors } from '@auth0/auth0-acul-react/mfa-sms-enrollment';
import BaseWrapper from 'creative-ui/oktaComponents/BaseWrapper';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { AuthErrorBanner } from '@/components/AuthErrorBanner/AuthErrorBanner';
import { useTrackErrors } from '@/hooks/useTrackErrors';
import { useTransactionLocale } from '@/hooks/useTranslationLocale';
import { trackClick, trackPageView } from '@/lib/tagging';

import MfaSmsEnrollmentForm from './components/MfaSmsEnrollmentForm';
import { useMfaSmsEnrollmentManager } from './hooks/useMfaSmsEnrollmentManager';

function MfaSmsEnrollmentScreen() {
  const { t } = useTranslation('mfaSmsEnrollment');
  useTransactionLocale();

  const { texts, handleTryAnotherMethod } = useMfaSmsEnrollmentManager();

  useEffect(() => {
    trackPageView('mfa/sms');
  }, []);

  const handleBack = () => {
    trackClick('mfa/sms/back');
    handleTryAnotherMethod();
  };

  const { errors } = useErrors();
  const { generalErrorMessages, fieldErrors } = useTrackErrors(
    errors,
    'mfa/sms/error',
  );

  // SDK first, i18n fallback
  document.title = texts?.pageTitle || t('page.title');

  const title = texts?.title || t('header.title');

  return (
    <BaseWrapper title={title} backCtaProps={{ onClick: handleBack }}>
      <AuthErrorBanner errors={generalErrorMessages} />
      <MfaSmsEnrollmentForm fieldErrors={fieldErrors} />
    </BaseWrapper>
  );
}

export default MfaSmsEnrollmentScreen;
